const state = {
  history: [],
  currentIndex: -1,
  direction: null,
  closePrevent: null,
  displayClosePrompt: false,
  actionOnCloseProceed: null
}
const getters = {
  modalHistory: state => state.history,
  modalOpen: state => state.currentIndex >= 0,
  currentModal: state => state.history[state.currentIndex] || null,
  currentModalComponent: state => state.history[state.currentIndex]?.component || null,
  currentModalIndex: state => state.currentIndex,
  modalStack: state => state.history.slice(0, state.currentIndex + 1),
  hasPreviousModal: state => state.currentIndex > 0,
  modalArgs: state => state.history[state.currentIndex]?.args,
  getModalHeaderTitle: state => state.history[state.currentIndex]?.headerTitle,
  getModalClosePrevent: state => state.closePrevent,
  displayModalClosePrompt: state => state.displayClosePrompt,
  actionOnModalCloseProceed: state => state.actionOnCloseProceed,
  modalDirection: state => state.direction,
  modalTransitionName: state => {
    if (state.direction === "back") return "slide-back"
    else if (state.direction === "forward") return "slide-forward"
    return null
  }
}
const mutations = {
  setActiveModal(state, modal) {
    const newModal = {
      id: crypto.randomUUID(),
      component: modal.component,
      args: modal.args || {},
      headerTitle: modal.headerTitle || null,
      mode: modal.mode,
      scrollTop: 0,
      index: state.history.length
    }

    const mode = modal.mode || "push"

    // Remove forward history if branching
    state.history = state.history.slice(0, state.currentIndex + 1)

    if (mode === "replace") {
      if (state.currentIndex >= 0) {
        state.history[state.currentIndex] = newModal
      } else {
        state.history.push(newModal)
        state.currentIndex = 0
      }
      state.direction = null
      return
    }

    if (mode === "reset") {
      state.history = [newModal]
      state.currentIndex = 0
      state.direction = null
      return
    }

    // default: push
    state.history.push(newModal)
    state.currentIndex++
    if (state.currentIndex > 0) state.direction = "forward"
    else state.direction = null
  },
  returnToPreviousModal(state, fromModalIndex) {
    if (state.closePrevent) {
      state.displayClosePrompt = true
      state.actionOnCloseProceed = "returnToPreviousModal"
      setTimeout(() => state.displayClosePrompt = false, 500)
      return
    }

    let currentIndex = typeof(fromModalIndex) == Number ? fromModalIndex : state.currentIndex

    if (currentIndex > 0) {
      state.currentIndex = currentIndex - 1
      state.direction = "back"
    }
  },
  closeModal(state) {
    if (state.closePrevent) {
      state.displayClosePrompt = true
      state.actionOnCloseProceed = "closeModal"
      setTimeout(() => state.displayClosePrompt = false, 500)
      return
    }

    state.history = []
    state.currentIndex = -1
    state.direction = "back"
  },
  removePreviousModals(state) {
    if (state.closePrevent) {
      state.displayClosePrompt = true
      state.actionOnCloseProceed = "removePreviousModals"
      setTimeout(() => state.displayClosePrompt = false, 500)
      return
    }
    state.direction = null
    state.activeModal = [state.activeModal.pop()]
  },
  setModalArgs(state, obj) {
    console.log("setting modal args for ", state.history[state.currentIndex]?.component)
    if (!state.history[state.currentIndex]) return
    state.history[state.currentIndex].args = obj
  },
  amendModalArgs(state, obj) {
    if (!state.history[state.currentIndex]) return
    state.history[state.currentIndex].args = { ...state.history[state.currentIndex].args, ...obj }
  },
  setModalTitle(state, title) {
    if (!state.history[state.currentIndex]) return
    state.history[state.currentIndex].headerTitle = title
  },
  setPreviousModalArgs(state, [index, obj]) {
    if (!state.history[index]) return
    state.history[index].args = obj
  },
  amendPreviousModalArgs(state, [index, obj]) {
    if (!state.history[index]) return
    state.history[index].args = { ...state.history[index].args, ...obj }
  },
  setModalScroll(state, { id, scrollTop }) {
    const modal = state.history.find(m => m.id === id)
    if (modal) {
      modal.scrollTop = scrollTop
    }
  },
  preventModalClose(state, arr) {
    state.closePrevent = arr
  },
  toggleModalClosePrompt(state, bool) {
    state.displayClosePrompt = bool
  }
}

export default {
  state,
  getters,
  mutations
}